import {
  AbstractMyAccountAuthService,
  UserModel,
} from '@aionzdev/modules';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { mapUsuarioToUserModel } from '../mappers/user.mapper';
import { AuthModuleService } from './auth-module.service';

@Injectable({ providedIn: 'root' })
export class MyAccountAuthService extends AbstractMyAccountAuthService {
  private readonly auth = inject(AuthModuleService);

  readonly userAuthenticatedChange$: Observable<UserModel> = this.auth.userAuthenticatedChange$.pipe(
    map(user => mapUsuarioToUserModel(user))
  );

  override me(): Observable<UserModel> {
    return this.auth.me().pipe(map(user => mapUsuarioToUserModel(user)));
  }
}
